import { use_slice_ui } from '@/hooks/store/use_slices';
import { PageSettingsUserViewsMobile } from './PageSettingsUserViewsMobile';
import { S_PAGE_LAYOUT__settings_user_desktop } from './S_PAGE_LAYOUT__settings_user_desktop';
import { WatcherSlugPageSettingsUser } from './watchers/WatcherSlugPageSettingsUser';

export function S_PAGE__settings_user() {
  const { global_is_mobile } = use_slice_ui(['global_is_mobile']);

  return (
    <>
      <WatcherSlugPageSettingsUser />
      {global_is_mobile ? <PageSettingsUserViewsMobile /> : <S_PAGE_LAYOUT__settings_user_desktop />}
    </>
  );
}
